import React, { useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import HelpSteps from "../../../Components/HelpSteps";
import StudentStories from "../../../Components/StudentStories";
import HelpService from "../../../Components/HelpService";
import "./Definition.scss";
import BonusSection from "../../../Components/BonusSection";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import Universities from "../../../Components/Universities";
// import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const Definition = () => {
  const subCatagoryId = "6586d3c2dafb1f4a8f4610e1";
  const categoryId = "65524e5e3c005ef3b51907c6";
  const [isModelOpen, setIsModelOpen] = useState(false);

  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

   const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Homework Help",},
    { label: "Do My Homework", }
  ]
  return (
    <div>
      <Page subCategoryId={subCatagoryId} categoryId={categoryId} />

      <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>
      <MainBanner id={subCatagoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection />
      <HelpService helpServiceTitle subCategoryID={subCatagoryId} description="Get access to helpful features, added support, and smart advantages designed for students" />
      <HelpSteps subCategoryId={subCatagoryId} description="Get your Homework support in 4 easy steps"/>
      {/* <Milestonerewards categoryId={categoryId} /> */}
      <BonusSection
        subCategoryId={subCatagoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ComWorldWide id={subCatagoryId} />
      <ComReadMoreSection id={subCatagoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "HomeworkHelp",
            type: "mcqHelp",
            totalSteps:1,
          }}
          subCategory={subCatagoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
      {/* <GetPopup /> */}
    </div>
  );
};

export default Definition;
